import { API_TAGS } from '@/shared/api';
import type { SearchQueryRequest } from './types/request';

export const searchKeys = {
  all: [API_TAGS.DIALOGS, 'search'] as const,
  conversations: () => [...searchKeys.all, 'conversations'] as const,
  rules: () => [...searchKeys.all, 'rules'] as const,
  knowledge: () => [...searchKeys.all, 'knowledge'] as const,
  knowledgeSets: () => [...searchKeys.all, 'knowledgeSets'] as const,
  query: (request: SearchQueryRequest) => [...searchKeys.all, request.entityType, request] as const,
  infiniteQuery: (params: Omit<SearchQueryRequest, 'limit' | 'offset'> & { pageSize?: number }) =>
    [...searchKeys.all, params.entityType, 'infinite', params] as const,
};
